import React from 'react';
import NotasEntradaItem from './NotasEntradaItem';
import './NotasEntradaList.css';

const NotasEntradaList = ({ notas, selectedNota, onSelectNota, isLoading }) => {
  if (isLoading) {
    return (
      <div className="notas-list-loading">
        <div className="loading-spinner-sm"></div>
        <span>Carregando notas...</span>
      </div>
    );
  }

  if (!notas || notas.length === 0) {
    return (
      <div className="notas-empty-state">
        <div className="empty-icon">📄</div>
        <p>Nenhuma nota de entrada encontrada</p>
      </div>
    );
  }

  return (
    <div className="notas-entrada-list">
      {notas.map((nota) => (
        <NotasEntradaItem
          key={`${nota.tenantId}-${nota.idEntrada}`}
          nota={nota}
          isSelected={
            selectedNota &&
            selectedNota.tenantId === nota.tenantId &&
            selectedNota.idEntrada === nota.idEntrada
          }
          onSelect={onSelectNota}
        />
      ))}
    </div>
  );
};

export default NotasEntradaList;
